<template>
  <div class="help">
    <HomeHeaderIndex></HomeHeaderIndex>
    <div class="bg">
      <div>
        <p class="p1">帮助中心</p>
        <p class="p2">Help Center</p>
      </div>
      <img :src="static_img_url + 'pic/index/helpbg.png'">
    </div>
    <div class="center">
      <div class="top">
        <div class="item">
          <div :class="{'active': active == 'introduced'}" @click="active = 'introduced'">
            <img :src="static_img_url + 'pic/index/iicon.png'" alt="">
            <span>功能介绍</span>
          </div>
        </div>
        <div class="item">
          <div :class="{'active': active == 'question'}" @click="active = 'question'">
            <img :src="static_img_url + 'pic/index/qicon.png'" alt="">
            <span>常见问题</span>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content-l" v-if="active == 'introduced'">
          <div class="sections-nav">
            <div v-for="value,key,index in introduced" class="item" :key="key" :class="{'active': introduced_type == key}" @click="introduced_type = key">{{key}}</div>
          </div>
        </div>
        <div class="content-r">
          <div class="introduced" v-html="introduced[introduced_type]" v-if="active == 'introduced'"></div>
          <div class="question" v-if="active == 'question'">
            <div class="item" v-for="item,index in question" :key="index">
              <div class="p1">
                <div>Q、</div>
                <div>{{item.q}}</div>
              </div>
              <div class="p2">
                <div>A、</div>
                <div>{{item.a}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HomeFooterIndex></HomeFooterIndex>
  </div>
</template>
<script>
import HomeHeaderIndex from '@/components/HomeHeaderIndex.vue'
import HomeFooterIndex from '@/components/HomeFooterIndex.vue'
export default {
  components: { HomeHeaderIndex, HomeFooterIndex },
  data() {
    return {
      active: 'introduced',
      introduced_type: '工作台Max',
      introduced:  {
        '工作台Max': `<p class="p2">功能说明：根据您关注的领域或追踪的企业，系统自动筛选出高价值资讯和信息。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、关注领域</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/1-1.png">
                      <p class="p2">2、追踪企业</p>
                      <p class="p2">方式1，使用Feed顶部信息流搜索栏，查找并发现符合您条件的企业，点击“添加关注”一键关注</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/1-2.png">
                      <p class="p2">方式2，点击信息流卡片旁边的“关注按钮”或点击浏览记录中企业旁边的“关注”按钮等方式</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/1-3.png">
                      <p class="p2">3、信息流展示</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/1-4.png">
                      `,
        '快讯Live': `<p class="p2">功能说明：展示动脉橙知识库发布的快讯。支持热门领域、时间、地区、话题类型、关注数据等字段筛选。右侧顶部支持快讯重要级筛选，支持浏览器弹框通知。列表支持快讯收藏和分享。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/2-1.png">
                      <p class="p2">2、选择右侧筛选</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/2-2.png">
                      <p class="p2">3、点击收藏、分享</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/2-3.png">
                      `,
        '专题Pro': `<p class="p2">功能说明：展示动脉橙知识库发布的专题，覆盖医疗领域投融资、科技、大公司等。支持关键词搜索、分类筛选等字段查询。支持收藏、分享专题。</p>
                      <p class="p2">另：单独整理了科技战疫版图。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/3-1.png">
                      <p class="p2">2、打开专题详情页，点击收藏、分享</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/3-2.png">
                      <p class="p2">3、点击分享表格</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/3-3.png">
                      <p class="p2">4、点击分享时间线</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/3-4.png">
                      <p class="p2">5、点击分享图谱</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/3-5.png">
                      <p class="p2">6、点击政策对比</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/3-6.png">
                      `,
        '数据': `      <p class="p1">并购事件列表</p>
                      <p class="p2">功能说明：展示动脉橙知识库收录的医疗类并购事件。支持行业领域、地区、并购事件、币种等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-1.png">
                      <p class="p2">2、选择排序方式</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-2.png">
                      <p class="p1">融资事件列表</p>
                      <p class="p2">功能说明：展示动脉橙知识库收录的医疗类融资事件。支持行业领域、获投轮次、地区、获投事件、币种等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-3.png">
                      <p class="p2">2、选择排序方式</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-4.png">
                      <p class="p1">公司列表</p>
                      <p class="p2">功能说明：展示动脉橙知识库收录的医疗类公司。支持公司领域、地区、成立时间等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-5.png">
                      <p class="p2">2、选择排序方式</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-6.png">
                      <p class="p1">金融机构列表</p>
                      <p class="p2">功能说明：展示动脉橙知识库收录的医疗类金融投资机构。支持投资领域、投资阶段、机构类型、资本来源、地区等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-7.png">
                      <p class="p2">2、选择排序方式</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-8.png">
                      <p class="p1">医院列表</p>
                      <p class="p2">功能说明：展示动脉橙知识库收录的医院。支持医院标签、医院等级、医院类型、地区、成立时间等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-9.png">
                      <p class="p2">2、选择排序方式</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-10.png">
                      <p class="p1">政策列表</p>
                      <p class="p2">功能说明：展示动脉橙知识库收录的政策。支持有效范围、发布时间等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-11.png">
                      <p class="p2">2、选择排序方式</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-12.png">
                      <p class="p1">招标采购列表</p>
                      <p class="p2">功能说明：展示动脉橙知识库收录的医疗类招标数据。支持项目标签、中标时间、中标金额、采购地区等字段筛选。招标采购模块需要购买动脉橙平台VIP才能查看完整的数据，只对普通用户和游客开放查询5条的权限。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-13.png">
                      <p class="p2">2、选择排序方式</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-14.png">
                      <p class="p1">报告列表</p>
                      <p class="p2">功能说明：展示动脉橙知识库收录的发布的报告和收录第三方的报告。支持报告类型、报告领域、发布时间等字段筛选。付费报告只对动脉橙平台VIP用户才开放，普通用户和游客不能查看付费报告，可以升级成为会员或者单独购买报告。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-15.png">
                      <p class="p2">2、付费报告</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-16.png">
                      <p class="p2">2、购买报告</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-17.png">
                      <p class="p1">活动列表</p>
                      <p class="p2">功能说明：展示动脉橙知识库收录的发布的活动和收录第三方的活动。支持会议时间、会议类型、会议地区、会议规模等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/4-18.png">
                      `,
        '研图View': `  
                      <p class="p2">功能说明：展示动脉橙知识库收录的医疗类投融资数据，将2010年至今的投融资数据按照图表进行可视化展示。包括投融资总趋势、当前热点领域、最新排行榜、投融资报告等模块。研图View只对动脉橙VIP客户开放，普通用户和游客只能查看当前默认页数据，不能筛选数据。</p>
                      <p class="p1" style="margin-top: 28px">投融资总趋势-融资额</p>
                      <p class="p2">功能说明：展示最近几年融资额数据。支持币种、年度/季度、地区、时间段等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择右侧筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-1.png">
                      <p class="p2">2、选择时间段</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-2.png">
                      <p class="p2">3、选择列表排序</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-3.png">
                      <p class="p1">投融资总趋势-平均融资额</p>
                      <p class="p2">功能说明：展示最近几年融资额和融资事件关系的数据，平均融资额=总融资额/融资事件数。支持币种、年度/季度、地区、时间段等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择右侧筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-4.png">
                      <p class="p2">2、选择时间段</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-5.png">
                      <p class="p2">3、选择列表排序</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-6.png">
                      <p class="p1">投融资总趋势-融资事件</p>
                      <p class="p2">功能说明：展示最近几年融资时间数据。支持年度/季度、地区、时间段等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择右侧筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-7.png">
                      <p class="p2">2、选择时间段</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-8.png">
                      <p class="p2">3、选择列表排序</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-9.png">
                      <p class="p1">投融资总趋势-领域分布</p>
                      <p class="p2">功能说明：展示最近几年热门领域融资额和融资事件数量关系的数据。支持币种、地区、时间段等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择右侧筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-10.png">
                      <p class="p2">2、选择时间段</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-11.png">
                      <p class="p2">3、选择列表排序</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-12.png">
                      <p class="p1">投融资总趋势-轮次分布</p>
                      <p class="p2">功能说明：展示最近几年融资轮次和融资事件数关系的数据。支持年度/季度、地区、时间段等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择右侧筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-13.png">
                      <p class="p2">2、选择时间段</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-14.png">
                      <p class="p2">3、选择列表排序</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-15.png">
                      <p class="p1">投融资总趋势-地区分布</p>
                      <p class="p2">功能说明：展示最近几年融资额和融资事件数在各地分布的数据。支持年度/季度、地区、时间段等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择右侧筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-16.png">
                      <p class="p2">2、选择时间段</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-17.png">
                      <p class="p2">3、选择列表排序</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-18.png">
                      <p class="p2">4、右侧地区选择国内</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-19.png">
                      <p class="p2">5、右侧地区选择国外</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-20.png">
                      <p class="p1">当前热点领域-融资事件</p>
                      <p class="p2">功能说明：展示最近几年热门领域融资事件数据。支持年度/季度、地区、时间段等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择右侧筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-21.png">
                      <p class="p2">2、选择时间段</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-22.png">
                      <p class="p2">3、选择列表排序</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-23.png">
                      <p class="p1">当前热点领域-融资额</p>
                      <p class="p2">功能说明：展示最近几年热门领域融资额数据。支持币种、年度/季度、地区、时间段等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择右侧筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-24.png">
                      <p class="p2">2、选择时间段</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-25.png">
                      <p class="p2">3、选择列表排序</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-26.png">
                      <p class="p1">当前热点领域-轮次分布</p>
                      <p class="p2">功能说明：展示最近几年热门领域融资额/融资事件和融资轮次/领域之间关系的数据。支持币种、年度/季度、地区、时间段等字段筛选。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择右侧筛选条件</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-27.png">
                      <p class="p2">2、选择时间段</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-28.png">
                      <p class="p2">3、选择列表排序</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-29.png">
                      <p class="p2">4、切换融资额和融资事件图表</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-30.png">
                      <p class="p1">最新排行榜-融资额TOP30</p>
                      <p class="p2">功能说明：展示最近1年融资额数据，排序按照融资额统一换算成人民币后倒序排序。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、列表数据显示</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-31.png">
                      <p class="p1">最新排行榜-投资机构TOP30</p>
                      <p class="p2">功能说明：展示最近1年投资机构投资数量倒序排序。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、列表数据显示</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-32.png">
                      <p class="p1">最新排行榜-FA机构TOP10</p>
                      <p class="p2">功能说明：展示最近1年FA机构服务数量倒序排序。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、列表数据显示</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-33.png">
                      <p class="p1">投融资报告</p>
                      <p class="p2">功能说明：展示动脉橙知识库发布和收录的投融资报告，按下载量倒序排序。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、列表数据显示</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/5-34.png">
                      `,
        '个人中心': `<p class="p2">功能说明：个人中心包括皮肤切换、收藏列表、优惠券列表、订单列表、购买列表、账号设置、退出等操作。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、点击个人中心</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/6-1.png">
                      <p class="p2">2、点击皮肤切换</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/6-2.png">
                      <p class="p2">3、点击查看收藏列表</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/6-3.png">
                      <p class="p2">4、点击订单列表</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/6-4.png">
                      `,
        '会员购买': `<p class="p2">功能说明：动脉橙会员有按天/月/1年/2年购买方式，购买后才能享受会员服务。</p>
                      <p class="p2">操作步骤：</p>
                      <p class="p2">1、选择会员时长</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/7-1.png">
                      <p class="p2">2、选择是否选用优惠券（没有优惠券则默认无）</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/7-2.png">
                      <p class="p2">3、微信扫码支付</p>
                      <img src="${this.$store.state.static_img_url}pic/index/help/7-3.png">
                      `
      },
      question: [
        { q: '为什么说平台信息覆盖全？', a: '目前涵盖全球超500个主流医疗媒体信源信息，7X24小时实时更新。' },
        { q: '动脉橙平台包含哪些行业数据库？', a: '包括全球健康产业近千万条数据，三大类，十七子类数据，持续更新中。' },
        { q: '动脉橙平台覆盖哪些细分领域信息？', a: '覆盖数字健康领域30+热门赛道全方位信息，提供持续动态更新的产业趋势报告，产业图谱，行业内参。' },
        { q: '个人版和机构版最大的区别是什么呢？', a: '您好，个人用户不支付导出功能，机构版提供精准筛选、下载和导出功能。' },
        { q: '机构版数据导出功能仅支持列表字段吗？', a: '您好，如果还有其他字段诉求可以联系17338335471（微信同号）进行反馈。' },
        { q: '忘记密码怎么办?', a: '您好，为了保障信息安全，请联系工作人员为您处理，咨询电话：17338335471（微信同号）。' },
        { q: '如何反馈意见、联系我们？', a: '您在使用动脉橙过程中，如遇任何使用问题，欢迎您随时联系我们。微信号：vcbeat_m，邮箱：liu.y@vcbeat.net。' },
        { q: '购买会员服务后可以退款吗？', a: '抱歉！动脉橙会员是虚拟服务产品，暂不接受退款。如有特别原因，请联系客服。' },
        { q: '如何开具会员发票？', a: '登录网站后，个人中心—订单管理—勾选订单—点击“开具发票”申请开具发票，如您有其他需求，请在右下脚选择咨询客服，扫码后会有专人为您处理。' }
      ]
    }
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    }
  },
  methods: {}
}
</script>
<style lang="stylus" scoped>
.help
  .bg
    height 400px
    display flex
    justify-content center
    overflow hidden
    position relative
    img
      display block
      height 400px
    div
      position absolute
      left 50%
      transform translateX(-50%)
      top 150px
      text-align center
      .p1
        font-size 40px
        font-weight 400
        line-height 56px
        color rgba(255, 255, 255, 1)
      .p2
        font-size 20px
        font-weight 400
        color rgba(255, 255, 255, 1)
        line-height 28px
        padding-left 2px
  .center
    width 1200px
    margin 0 auto
    position relative
    padding 56px 0 40px
    .top
      background-color #fff
      display flex
      height 80px
      width 100%
      left 0
      top -40px
      z-index 2
      position absolute
      box-shadow 0px 4px 30px 0px rgba(109,93,79,0.1)
      .item
        flex 1
        display flex
        justify-content center
        align-items center
        position relative
        > div
          display flex
          align-items center
          cursor pointer
          &.active
            span
              color #FA7A50
              font-weight bold
          &:hover
            span
              color: #FA7A50
        img
          height 36px
        span
          font-size 20px
          color #333
          margin-left 6px
      .item+.item:before
        content: ''
        position absolute
        width 1px
        height 28px
        background #e9e9e9
        top 50%
        transform translateY(-50%)
        left 0
    .content
      padding 60px 160px 40px
      background-color #fff
      box-shadow 0px 4px 30px 0px rgba(109,93,79,0.1)
      display flex
      justify-content center
      &-l
        width 148px
        margin 0 60px 0 12px
        .sections-nav
          width 148px
          .item
            color #999999
            width 148px
            height 44px
            display flex
            justify-content center
            align-items center
            cursor pointer
            font-size: 14px
            &.active
              background #fffbf7
              border 1px solid #fa7a50
              color #fa7a50
            &:hover
              color #fa7a50
      &-r
        width 660px
        .introduced
          >>> .p1
            font-size 18px
            color #333
            font-weight 600
            &~.p1
              margin-top 28px
          >>> .p2
            font-size 14px
            font-weight 400
            color rgba(102, 102, 102, 1)
            line-height 24px
            margin-top 12px
          >>> img
            display block
            margin 0 auto
            max-width 100% !important
            border #F5F5F5 10px solid
            margin-top 12px
        .question
          .item
            > div
              display flex
            .p1
              font-size 18px
              font-weight 600
              color rgba(51, 51, 51, 1)
              line-height 22px
            .p2
              margin-top 10px
              color #666666
              line-height 24px
              > div:first-child
                color #FA7A50
                font-size 18px
                font-weight 600
              > div:last-child
                font-size 14px
          .item+.item
            margin-top: 25px
</style>